import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import formatId from "lib/formatId";

const ColumnItem = React.forwardRef((props, ref) => {
    const {
        label,
        datakey,
        nestLevel,
        childCount,
        selected,
        expanded,
        ITid,
    } = props;

    const onSelect = (e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onSelect();
    };

    const onExpanderClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        props.changeExpanded();
    };

    const expandable = datakey != null && nestLevel === 0;
    const classes = classNames("children-possible", {
        [`nest-${nestLevel}`]: nestLevel != null,
        [datakey]: datakey != null,
        "expandable": expandable,
        "children-exist": childCount > 0,
        "active": selected,
        "expanded": expanded,
    });

    return <li
        ref={ref}
        className={classes}
        onClick={onSelect}
        id={formatId(ITid, "nav-item")}
    >
        <i className={classNames("expander", "glyphicon", expandable ? {
            "glyphicon-triangle-right": !expanded,
            "glyphicon-triangle-bottom": expanded,
        } : "glyphicon-placeholder")}
           onClick={onExpanderClick}
           data-key={datakey} />
        {label}
    </li>;
});

ColumnItem.propTypes = {
    label: PropTypes.string.isRequired,
    datakey: PropTypes.string,
    nestLevel: PropTypes.number,
    selected: PropTypes.bool,
    childCount: PropTypes.number,
    onSelect: PropTypes.func.isRequired,
    changeExpanded: PropTypes.func.isRequired,
    expanded: PropTypes.bool,
    ITid: PropTypes.any,
};

export default ColumnItem;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/views/ColumnItem.js